export default __webpack_public_path__ + "static/media/media-flyer-5.7a1484c7.jpg";